// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aLM1","name":"styles_name__12A2C","phone":"styles_phone__2-T7G"};